import React, { useCallback, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { NavDropdown } from "react-bootstrap";
import { useHistory } from "react-router";
import { AuthorizationVerifier } from "../../components/authorization-verifier";

export interface AccordionMenuItemProps {
  href?: string;
  route?: string;
  message: {
    id: string;
    defaultMessage: string;
  };
  target?: string;
  section?: string;
  showSvg?: boolean;
}

export function AccordionMenuItem({ href, route, message, section, showSvg = false }: AccordionMenuItemProps) {
  const history = useHistory();

  const isLegacy = useMemo(() => {
    return href !== undefined;
  }, [href]);
  
  const handleClick = useCallback(() => {
    if (route) {
      history.push(route);
    } else {
      console.error("No route and no href on menu item. Will do nothing.");
    }
  }, [history, route]);

  return (
    <AuthorizationVerifier section={section} showForbiddenMessage={false}>
      <NavDropdown.Item
        href={isLegacy ? href : undefined}
        onClick={isLegacy ? undefined : handleClick}
      >
        {showSvg &&
        <svg style={{margin: "0px 8px", opacity: "0.5"}} fontSize="8px" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" className="bi bi-chevron-up" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
          </svg>
        }
        <FormattedMessage {...message} />
      </NavDropdown.Item>
    </AuthorizationVerifier>
  );
}